<template>
  <hr class="divider" />
</template>

<script>
export default {
  name: 'Divider',
};
</script>

<style lang="postcss">
.divider {
  margin: 30px 0px;
}
</style>
